import React from 'react';
import { profile } from '../data/site';
type PortraitFrameProps = {
  className?: string;
};
export function PortraitFrame({
  className = ''
}: PortraitFrameProps) {
  return <figure className={`relative mx-auto w-full max-w-sm ${className}`} data-id="element-85" data-mp="1pik56jikmw38">
      <span className="absolute -left-4 -top-4 h-full w-full border border-brass-500" aria-hidden="true" data-id="element-86" data-mp="1pkmrotkim737" />
      <div className="relative bg-ivory p-3 shadow-[0_24px_60px_-32px_rgba(11,23,35,0.6)]" data-id="element-87" data-mp="2i6y36z9ntses">
        <div className="border border-stone p-1" data-id="element-88" data-mp="2d84mkxz2tlae">
          <img src={profile.photo} alt={`Portrait of ${profile.shortName}`} className="block h-auto w-full object-cover" data-id="element-89" data-mp="2d9fqqywfov21" />
        </div>
        <figcaption className="border-t border-stone px-2 pb-1 pt-4 text-center" data-id="element-90" data-mp="23j3676omd1vw">
          <span className="block font-display text-base text-ink-950" data-id="element-91" data-mp="30y8rr9rwxt3i">
            {profile.name}
          </span>
          <span className="mt-1.5 block text-[11px] font-semibold uppercase tracking-[0.18em] text-brass-500" data-id="element-92" data-mp="2w6qsqr9ga2l6">
            Physician Executive & Venture Advisor
          </span>
        </figcaption>
      </div>
    </figure>;
}